import React, { Fragment, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { DialogComponent } from "../../common/DialogComponent";
import BreachRiskRatingInfo from "../RiskRating/BreachRiskRatingInfo";
import RemoveBreachInfo from "../RemoveBreachInfo";
import BreachBoxDescription from "./BreachBoxDescription";
import ExposureTableHead from "./ExposureTableHead";
import DetectedBreachTableBody from "./DetectedBreachTableBody";
import SavedBreachTableBody from "./SavedBreachTableBody";
import BreachPagination from "../SearchBreaches/BreachPagination";

const BreachExposureTable = ({
    detectedBreachData,
    savedBreachData,
    isDetectedLoading,
    isSavedLoading,
    handleSaveBreachSort,
    handleDetectedBreachSort,
    getNewData,
    sortState,
    isRemoveCall,
    setIsRemoveCall,
    setSortState,
}: any) => {
    const handleSort = (name: string, tableName: string) => {
        if (tableName === "savedBreach") {
            handleSaveBreachSort(name);
            setSortState({
                ...sortState,
                savedBreach: {
                    ...sortState.savedBreach,
                    [name]: !sortState.savedBreach[name],
                },
            });
        } else {
            handleDetectedBreachSort(name);
        }
    };

    const renderSortArrow = (name: string, tableName: string, arrowClick?: any) => {
        return (
            <span
                style={{ padding: "0px 4px", cursor: "pointer" }}
                onClick={() => {
                    handleSort(name, tableName);
                    if (arrowClick) {
                        arrowClick();
                    }
                }}
            >
                <em className="las la-sort-up" style={{ display: "block", lineHeight: "0.3", paddingTop: "3px" }}></em>
                <em className="las la-sort-down" style={{ display: "block" }}></em>
            </span>
        );
    };
    const [isRiskDialogOpen, setIsRiskDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [breachDetail, setBreachDetail] = useState({
        orgName: "",
        breachID: "",
    });
    const [detectedPage, setDetectedPage] = useState(1);
    const [savedPage, setSavedPage] = useState(1);
    const [titleNameDetectedBreach, setTitleNameDetectedBreach] = useState("");
    const [titleNameSavedBreach, setTitleNameSavedBreach] = useState("");
    const history = useHistory();

    const closeDialog = () => {
        setIsRiskDialogOpen(false);
    };

    const closeDeleteDialog = () => {
        setIsDeleteDialogOpen(false);
    };

    const handleRemove = () => {
        setIsRemoveCall(true);
    };

    return (
        <>
            <table role="table">
                <tbody>
                    <tr>
                        <td>
                            <table className={`${!isDetectedLoading ? "breach-exposure-table" : "loading breach-exposure-table"}`} role="table" >
                                <ExposureTableHead
                                    renderSortArrow={renderSortArrow}
                                    tableName="detectedBreach"
                                    handleSort={handleSort}
                                    setIsRiskDialogOpen={setIsRiskDialogOpen}
                                    setTitleNameDetectedBreach={setTitleNameDetectedBreach}
                                    titleNameDetectedBreach={titleNameDetectedBreach}
                                    sortState={sortState}
                                />
                                {detectedBreachData && detectedBreachData.length ? (
                                    <tbody>
                                        <DetectedBreachTableBody
                                            rowBreachData={detectedBreachData}
                                            detectedPage={detectedPage}
                                            titleNameDetectedBreach={titleNameDetectedBreach}
                                        />
                                    </tbody>
                                ) : <tbody>
                                        <tr className="null-body-detected-breach">
                                            <td role="cell" colspan="5">
                                                <div className="row row-container">
                                                    <div className="col-sm-3"></div>
                                                    <div className="col-xs-12 col-sm-6 text-align-center col-main">
                                                        <div className="icon-main">
                                                            <em className="las la-check-circle complete-icon"></em>
                                                        </div>
                                                        <div>
                                                            <div className="title-main">You do not have any detected breach exposures.</div>
                                                            <div className="description">
                                                                BreachIQ is continuously monitoring your data. We will notify you if we detect your data has been exposed in a
                                                                breach.
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-3"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                }
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {detectedBreachData && detectedBreachData.length > 5 ? (
                                <div className="breach-paging-container">
                                    <BreachPagination
                                        pageSize={5}
                                        currentPageNo={detectedPage}
                                        onChange={(val: number) => {
                                            setDetectedPage(val);
                                        }}
                                        numberOfRecord={detectedBreachData && detectedBreachData.length}
                                    />
                                </div>
                            ) : null}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="box" style={{ padding: "1.5rem 0px 0px 0px " }}>
                                <BreachBoxDescription
                                    title="Saved Searches"
                                    description={
                                        <span>
                                            The list below includes data breaches you've saved from your
                                            <Link
                                                to="/"
                                                className="default_link"
                                                onClick={(e: any) => {
                                                    e.preventDefault();
                                                    history.push({
                                                        pathname: `/breaches/search-breaches`,
                                                    });
                                                }}
                                                style={{ padding: "5px" }}
                                            >
                                                breach searches.
                                            </Link>
                                        </span>
                                    }
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table className={`${!isSavedLoading ? "breach-exposure-table" : "loading breach-exposure-table"}`}>
                                <ExposureTableHead
                                    renderSortArrow={renderSortArrow}
                                    tableName="savedBreach"
                                    handleSort={handleSort}
                                    setIsRiskDialogOpen={setIsRiskDialogOpen}
                                    setTitleNameSavedBreach={setTitleNameSavedBreach}
                                    titleNameSavedBreach={titleNameSavedBreach}
                                    sortState={sortState}
                                />
                                <tbody>
                                    <SavedBreachTableBody
                                        rowBreachData={savedBreachData}
                                        setIsDeleteDialogOpen={setIsDeleteDialogOpen}
                                        setIsLoading={setIsLoading}
                                        breachDetail={breachDetail}
                                        setBreachDetail={setBreachDetail}
                                        isRemoveCall={isRemoveCall}
                                        setIsRemoveCall={setIsRemoveCall}
                                        getNewData={getNewData}
                                        savedPage={savedPage}
                                        titleNameSavedBreach={titleNameSavedBreach}
                                        setSavedPage={setSavedPage}
                                    />
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {savedBreachData && savedBreachData.length > 5 ? (
                                <div className="breach-paging-container">
                                    <BreachPagination
                                        pageSize={5}
                                        currentPageNo={savedPage}
                                        onChange={(val: number) => {
                                            setSavedPage(val);
                                        }}
                                        numberOfRecord={savedBreachData && savedBreachData.length}
                                    />
                                </div>
                            ) : null}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div className="risk-rating-dialog">
                {isRiskDialogOpen && (
                    <DialogComponent dialogId="dialog-risk-rating-info" title="Breach Risk Rating Info" closeDialog={closeDialog}>
                        <BreachRiskRatingInfo closeDialog={closeDialog} />
                    </DialogComponent>
                )}
            </div>
            <div className="risk-rating-dialog">
                {isDeleteDialogOpen && (
                    <DialogComponent dialogId="dialog-risk-rating-info" title="Breach Risk Rating Info" closeDialog={closeDeleteDialog}>
                        <RemoveBreachInfo closeDialog={closeDeleteDialog} isLoading={isLoading} organization={breachDetail.orgName} handleRemove={handleRemove} />
                    </DialogComponent>
                )}
            </div>
        </>
    );
};

export default BreachExposureTable;
